import { Stack, StackProps, styled } from '@mui/material';

export const Course = styled((props: StackProps) => <Stack gap={3} component="li" {...props} />)(
  ({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    /** styles overridden by ListItem custom component should be marked important to take precendence */
    alignItems: 'stretch !important',
    padding: `${theme.spacing(5)} !important`,
  })
);
